module.exports = __webpack_public_path__ + "img/biter-die-3.01ddaaa5.png";